var render, staticRenderFns
import script from "./BaseDataTable.vue?vue&type=script&lang=ts&"
export * from "./BaseDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./BaseDataTable.vue?vue&type=style&index=0&id=a2611e00&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2611e00",
  null
  
)

export default component.exports